// storage.js — работа с историей приёмов через сервер
import { loadHistory as apiLoadHistory, saveMealToHistory, deleteMealFromHistory, updateMealInHistory } from './api';

let cachedHistory = [];
let currentLogin = null;

const getAuth = () => {
    const saved = localStorage.getItem('currentUser');
    if (!saved) return null;
    try {
        const user = JSON.parse(saved);
        return { login: user.login, token: user.token };
    } catch (e) {
        return null;
    }
};

// Сохранить приём
export const saveMeal = async (mealData, userProfile) => {
    const auth = getAuth();
    if (!auth) return null;

    const newMeal = {
        id: String(Date.now()),
        timestamp: new Date().toISOString(),
        date: new Date().toLocaleDateString('ru-RU'),
        time: new Date().toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
        mealText: mealData,
        userProfile: { ...userProfile }
    };

    const data = await saveMealToHistory(auth.login, auth.token, newMeal);
    if (data.success) {
        cachedHistory.unshift(newMeal);
        return newMeal;
    }
    if (data.error) {
        const isTokenError = data.error.includes('Недействительный токен') || data.error.includes('Invalid token');
        if (isTokenError) {
            cachedHistory = [];
            currentLogin = null;
            return { success: false, error: 'invalid_token' };
        }
        console.warn('Ошибка сохранения:', data.error);
    }
    return null;
};

// Загрузить историю с сервера
export const loadHistory = async () => {
    const auth = getAuth();
    if (!auth) {
        cachedHistory = [];
        currentLogin = null;
        return { success: false, error: 'no_auth' };
    }

    const data = await apiLoadHistory(auth.login, auth.token);
    if (data.success) {
        cachedHistory = data.history || [];
        currentLogin = auth.login;
        return { success: true, history: cachedHistory };
    }
    if (data.error) {
        // Проверяем, не токен ли проблема
        const isTokenError = data.error.includes('Недействительный токен') || data.error.includes('Invalid token');
        if (isTokenError) {
            cachedHistory = [];
            currentLogin = null;
            return { success: false, error: 'invalid_token' };
        }
        console.warn('Ошибка загрузки истории:', data.error);
    }
    return { success: false, error: 'unknown' };
};

// Получить историю из кэша
export const getHistory = () => {
    const auth = getAuth();
    if (!auth || auth.login !== currentLogin) return [];
    return cachedHistory;
};

// Получить историю за дату
export const getHistoryByDate = (date) => {
    return cachedHistory.filter(meal => meal.date === date);
};

// Все уникальные даты
export const getAllDates = () => {
    const dates = [...new Set(cachedHistory.map(meal => meal.date))];
    return dates.sort().reverse();
};

// Удалить приём
export const deleteMeal = async (id) => {
    const auth = getAuth();
    if (!auth) return;

    const meal = cachedHistory.find(m => m.id === String(id));
    if (!meal) return;

    const data = await deleteMealFromHistory(auth.login, auth.token, { id: String(id) });
    if (data.success) {
        cachedHistory = cachedHistory.filter(m => m.id !== String(id));
    }
};

// Обновить приём
export const updateMeal = async (id, updatedFields) => {
    const auth = getAuth();
    if (!auth) return null;

    const meal = cachedHistory.find(m => m.id === String(id));
    if (!meal) return null;

    const updatedMeal = { ...meal, ...updatedFields };
    const data = await updateMealInHistory(auth.login, auth.token, updatedMeal);
    if (data.success) {
        cachedHistory = cachedHistory.map(m => m.id === String(id) ? updatedMeal : m);
        return updatedMeal;
    }
    return null;
};

// Очистить всю историю
export const clearHistory = async () => {
    const auth = getAuth();
    if (!auth) return;
    for (const meal of [...cachedHistory]) {
        await deleteMealFromHistory(auth.login, auth.token, { id: meal.id });
    }
};

// Очистить кэш при выходе
export const clearCache = () => {
    cachedHistory = [];
    currentLogin = null;
};
